export const PARALLEL_CANDIDATE_RERANK_MIN_WIN_MARGIN = 0.045;

export interface CandidateRerankProbeLike {
  candidateIndex: number;
  geometryScore: number;
  confidence: number | null;
  templateScore: number;
  rerankScore?: number;
}

export function computeCandidateRerankScore(input: {
  geometryScore: number;
  confidence: number | null;
  templateScore: number;
}): number {
  const confidenceBonus = input.confidence === null
    ? 0
    : Math.max(0, Math.min(1, input.confidence / 100)) * 0.035;
  const templateBonus = input.templateScore * 0.025;
  return input.geometryScore + confidenceBonus + templateBonus;
}

export function selectCandidateRerankWinner<T extends { candidateIndex: number; rerankScore: number }>(
  probes: readonly T[],
  originalCandidateIndex: number,
): T | null {
  if (probes.length === 0) return null;
  const sorted = [...probes].sort((left, right) => right.rerankScore - left.rerankScore || left.candidateIndex - right.candidateIndex);
  const original = sorted.find((probe) => probe.candidateIndex === originalCandidateIndex) ?? sorted[0] ?? null;
  const best = sorted[0] ?? original;
  if (!best || !original) return original;
  return best.candidateIndex !== original.candidateIndex
    && best.rerankScore >= original.rerankScore + PARALLEL_CANDIDATE_RERANK_MIN_WIN_MARGIN
    ? best
    : original;
}
